export const getSelectedFilters = <T extends object>(
  filters: T | undefined,
  discardedFilters?: (keyof T)[]
): (keyof T)[] => {
  if (!filters) return []

  const selectedFilters = Object.entries(filters)
    .filter(([key, v]) => {
      const value = v as T[keyof T] // Explicitly type value

      // Skip filters in the discardedFilters array
      if (discardedFilters && discardedFilters.includes(key as keyof T)) return false

      // Check if value is not null or undefined
      if (value === null || value === undefined) return false

      // Check if it's a string and is non-empty
      if (typeof value === 'string' && value.trim().length === 0) return false

      // Check if it's an array and is non-empty
      if (Array.isArray(value) && value.length === 0) return false

      // Check if the value is a Date object and it's valid
      if (value instanceof Date && !isNaN(value.getTime())) return true // Dates are valid filters

      // Check if it's an object (excluding arrays and dates) and is non-empty
      if (
        typeof value === 'object' &&
        !Array.isArray(value) &&
        !(value instanceof Date) &&
        Object.keys(value).length === 0
      )
        return false

      // Otherwise, consider it a valid filter
      return true
    })
    .map(([key]) => key as keyof T)

  return selectedFilters
}

export const countFilters = <T extends object>(
  filters: T | undefined,
  discardedFilters?: (keyof T)[]
) => {
  if (!filters) return 0
  return getSelectedFilters(filters, discardedFilters).length
}
